import { _pHttp } from "../_pHttp";

export async function addTicketSpecial(body: any) {
  await _pHttp.post(`/tickets/special`, body);
}

export const getTicketSpecialList = async ({ page, numberInPage, search }: any) => {
  const { data } = await _pHttp.get(
    `tickets/special?page=${page}&numberInPage=${numberInPage}&search=${search}`
  );
  return data;
};
  

export const getTicketListWithTicketCountSpecial = async ({ page, numberInPage, search,  }: any) => {
  const { data } = await _pHttp.get(
    `ticket-matches/with-ticket-count/special?page=${page}&numberInPage=${numberInPage}&search=${search}`
  );
  return data;
};

export async function deleteTicketListSpecial(id: any) {
  return _pHttp.delete(`/tickets/special/${id}`);
}

export const getTicketSpecialTable = async ({ page, numberInPage, search,matchId }: any) => {
  const { data } = await _pHttp.get(
    `tickets/special/${matchId}?page=${page}&numberInPage=${numberInPage}&search=${search}`
  );
  return data;
};